import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import Me from "../helpers/me";
import App from "../helpers/app";
import Api from "../helpers/api";
import { take } from "rxjs/operators";
import * as moment from "moment";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";
import { ExcelService } from "app/helpers/excel.service";
import { JwtHelper } from "../helpers/jwt-helper";
import { MatriculaServidorHelper } from "../shared/services/matricula-servidor.helper";

import * as chartsData from "../shared/data/chartSample";
import { FormBuilder, FormGroup } from "@angular/forms";

/*
LISTA DE TAREFAS:
TODO - Formatar campos do form e implementar sistema de editar e salvar
TODO - Deixar a primeira matrícula padrão selecionada
TODO - Implementar a estrutura de gráfico e tabelas
TODO - implementar gráfico
TODO - implementar Métodos de adicionar salário ou importar atrelado a matrícula
TODO - implementar Métodos de adicionar cargo anterior atrelado a matrícula
TODO - Método no ngbTab anterior para carregar os dados do movimento selecionado
*/

@Component({
  selector: "app-dados-funcionais",
  templateUrl: "./dados-funcionais.component.html",
  styleUrls: ["./dados-funcionais.component.scss"],
})
export class DadosFuncionaisComponent implements OnInit {
  apiCall = this.api.new().silent();
  page = 1;
  pageSize = 10;
  pageS = 1;
  pageSizeS = 5;
  pageC = 1;
  pageSizeC = 10;
  idServidor;
  matriculaTabAtiva: string = null;
  movimentosFuncionais = [];
  cargosAnteriores = [];
  movimentosMensais = [];
  regimes = ["RPPS (Próprio Ente)", "RGPS", "RPPS (Outro Ente)"];
  cargashora = ["20 H", "25 H", "30 H", "40 H"];
  exoneracoes = [
    "Exoneração",
    "Demissão",
    "Rescisão",
    "Termo Final",
    "Devolução ao Órgão de Origem",
    "Falecimento",
    "Cassação",
    "Exoneração - A pedido",
    "Exoneração - Abandono de cargo",
    "Exoneração - Não Tomou Posse",
    "Exoneração - Não Entrou em Exercício",
    "Demissão por Justa Causa",
    "Termino de mandato",
    "Aposentadoria",
  ];

  naturalizados = [
    {
      id: 1,
      name: "Sim",
    },
    {
      id: 2,
      name: "Não",
    },
  ];
  acumulacoes = [
    {
      id: 1,
      name: "Não",
    },
    {
      id: 2,
      name: "No Mesmo Município",
    },
    {
      id: 3,
      name: "Em Outro Município",
    },
    {
      id: 4,
      name: "Na Esfera Estadual",
    },
    {
      id: 5,
      name: "Na Esfera Federal",
    },
  ];
  situacoes = [
    {
      id: 1,
      name: "Em Exercício",
    },
    {
      id: 2,
      name: "Em Auxilio (a)",
    },
    // {
    //   id: 3,
    //   name: "Aposentado (a)",
    // },
    // {
    //   id: 4,
    //   name: "Pensionista",
    // },
    // {
    //   id: 5,
    //   name: "Recluso (a)",
    // },
    {
      id: 6,
      name: "Outros",
    },
  ];

  carreirasDefault = [
    {
      id: 1,
      name: "Aposentadoria",
    },
    {
      id: 2,
      name: "Pensão",
    },
    {
      id: 3,
      name: "Professor",
    },
    {
      id: 4,
      name: "Auxílio Doença",
    },
    {
      id: 5,
      name: "Outros",
    },
  ];
  carreiras = [
    {
      id: 1,
      name: "Aposentadoria",
    },
    {
      id: 2,
      name: "Pensão",
    },
    {
      id: 3,
      name: "Professor",
    },
    {
      id: 4,
      name: "Auxílio Doença",
    },
    {
      id: 5,
      name: "Outros",
    },
  ];
  carreirasAtivo = [
    {
      id: 6,
      name: "Professor",
    },
    {
      id: 7,
      name: "Especial (Agentes Nocivos)",
    },
    {
      id: 8,
      name: "Outros Cargos",
    },
    {
      id: 21,
      name: "Militares",
    },
  ];
  carreirasAposentado = [
    { name: "Aposentadoria por Idade", id: 9 },
    { name: "Aposentadoria por Tempo de Contribuição", id: 10 },
    { name: "Aposentadoria Compulsória", id: 11 },
    { name: "Aposentadoria por Invalidez", id: 12 },
    { name: "Aposentadoria como Professor", id: 13 },
    {
      name: "Aposentadoria Especial - atividade de risco (Art. 40, § 4o, inc. II, CF)",
      id: 14,
    },
    {
      name: "Aposentadoria Especial - atividade prejudiciais à saúde ou integridade física (Art. 40, § 4o, inc. III, CF)",
      id: 15,
    },
    { name: "Militares Inativos - Reserva Remunerada", id: 16 },
    { name: "Militares Inativos - Reforma", id: 17 },
  ];
  carreirasPensionista = [
    {
      id: 18,
      name: "Vitalícia",
    },
    {
      id: 19,
      name: "Temporária",
    },
  ];
  carreirasExonerado = [
    {
      id: 20,
      name: "Exonerado",
    },
  ];
  tipoFundo = [
    "Fundo em Capitalização",
    "Fundo em Repartição",
    "Mantidos pelo Tesouro",
  ];
  servidor = null;
  estados = [];
  orgaos = [];
  cidades = [];
  cidade = null;
  isConferidor: boolean = false;
  idCidade: number = null;
  modoSomenteLeitura: boolean = false;

  cargo = {
    id: null,
    id_servidor: null,
    cargo: null,
    salario: null,
    inicio: null,
    fim: null,
  };
  salario = {
    id: null,
    id_servidor: null,
    valor: null,
    data: null,
    observacoes: null,
  };
  movimentoSelecionado = {
    id: null,
    id_servidor: null,
    id_matricula: null,
    tipo_vinculo: "Concursado",
    matricula: null,
    decreto_nomeacao: null,
    data_nomeacao: null,
    data_exercicio: null,
    classificacao_concurso: null,
    edital_concurso: null,
    data_posse: null,
    ente_origem: null,
    cargo_acumulacao: null,
    compatibilidade_horario: null,
    detalhes_acumulacao: null,
    regime_previdenciario: null,
    resolucao_registro: null,
    lei_autorizativa: null,
    base_legal: null,
    data_movimentacao: null,
    situacao_funcional: null,
    orgao: null,
    poder_orgao: null,
    carreira: null,
    ingresso_carreira: null,
    cargo: null,
    ingresso_cargo: null,
    carga_horaria: null,
    data_saida: null,
    tipo_exoneracao: null,
    local_trabalho: null,
    salario_base: null,
    nivel_classe: null,
    total: null,
    abono_permanencia: null,
    competencia_inicial: null,
    observacoes: null,
    tipo_fundo: null,
  };
  isEditingMatricula: boolean = false;
  isEditingGeneralData: boolean = false;
  clonedMatricula: any = null;
  clonedGeneralDate: any = null;

  movimentosMensaisFiltered = [];
  cargosAnterioresFiltered = [];

  lineChartData = chartsData.lineChartData;
  lineChartLabels = chartsData.lineChartLabels;
  lineChartOptions = chartsData.lineChartOptions;
  lineChartColors = chartsData.lineChartColors;
  lineChartLegend = chartsData.lineChartLegend;
  lineChartType = chartsData.lineChartType;

  filterForm: FormGroup;

  orderOptions = [
    { label: "Mais Novo > Mais Antigo", value: "desc" },
    { label: "Mais Antigo > Mais Novo", value: "asc" },
  ];

  limitOptions = [3, 5, 10, 20];

  constructor(
    private router: Router,
    private excelService: ExcelService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private me: Me,
    private app: App,
    private api: Api,
    private fb: FormBuilder
  ) {
    this.filterForm = this.fb.group({
      fromDate: [""],
      toDate: [""],
      order: ["desc"],
      limit: [3],
    });
  }
  async ngOnInit() {
    const self = this;
    const parametros = self.route.snapshot.queryParams;
    const idMatriculaSelecionada = parametros["id_matricula"];
    if (parametros["id"]) {
      self.idServidor = parametros["id"];
    }
    self.estados = [];
    self.movimentosFuncionais = [];
    self.orgaos = [];
    self.cidades = [];
    self.resetaMovimento();
    const dadosUsuario = this.me.currentUserValue;
    const json = JSON.parse(JSON.stringify(dadosUsuario));

    if (dadosUsuario && dadosUsuario.token) {
      self.isConferidor = JwtHelper.isConferidor(dadosUsuario.token);
    }
    self.modoSomenteLeitura = self.isConferidor && parametros["modo"] === "visualizacao";

    if (self.isConferidor) {
      if (parametros["idCidade"]) {
        self.idCidade = parseInt(parametros["idCidade"]);
      } else {
        await self.app.alert('Erro!', 'ID da cidade não fornecido.', 'error');
        self.router.navigate(['/page/conferidor/municipios']);
        return;
      }
    } else {
      self.idCidade = json.user.cidade;
    }

    const cidade = self.idCidade;
    this.cidade = cidade;
    const nomeCidade = json.user.nomeCidade;
    await self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    const estados = await self.apiCall
      .get("enderecos/estados")
      .pipe(take(1))
      .toPromise();
    self.estados = JSON.parse(JSON.stringify(estados));
    const orgaos = await self.apiCall
      .get("enderecos/estados/cidades/orgaos/todos/ativo?cidade=" + cidade)
      .pipe(take(1))
      .toPromise();
    if (orgaos) self.orgaos = JSON.parse(JSON.stringify(orgaos));
    console.log("orgaos", self.orgaos);
    const movimentos = await self.apiCall
      .get(`servidor/movimentos/todos?id_servidor=${self.idServidor}${idMatriculaSelecionada ? `&id_matricula=${idMatriculaSelecionada}` : ''}`)
      .pipe(take(1))
      .toPromise();
    if (movimentos)
      self.movimentosFuncionais = JSON.parse(JSON.stringify(movimentos));
    const cargos = await self.apiCall
      .get(
        "servidor/movimentos/cargosanteriores/recuperar?id_servidor=" +
          self.idServidor
      )
      .pipe(take(1))
      .toPromise();
    if (cargos) self.cargosAnteriores = JSON.parse(JSON.stringify(cargos));
    const movimentacoesmensais = await self.apiCall
      .get(
        "servidor/movimentos/movimentacoesmensais/recuperar?id_servidor=" +
          self.idServidor
      )
      .pipe(take(1))
      .toPromise();
    if (movimentacoesmensais)
      self.movimentosMensais = JSON.parse(JSON.stringify(movimentacoesmensais));

    const servidor = await self.apiCall
      .get(`servidor?id=${self.idServidor}&id_cidade=${cidade}${idMatriculaSelecionada ? `&id_matricula=${idMatriculaSelecionada}` : ''}`)
      .pipe(take(1))
      .toPromise();
    if (!servidor || typeof servidor === 'string') {
      await self.spinner.hide();
      await self.app.alert('Erro!', 'Servidor não encontrado.', 'error');
      return;
    }
    self.servidor = MatriculaServidorHelper.normalizarServidor(JSON.parse(JSON.stringify(servidor)), cidade);
    if (self.servidor.status && self.servidor.status == 1) {
      self.carreiras = [...self.carreirasAtivo];
    } else if (self.servidor.status && self.servidor.status == 2) {
      self.carreiras = [...self.carreirasAposentado];
    } else if (self.servidor.status && self.servidor.status == 3) {
      self.carreiras = [...self.carreirasPensionista];
    } else if (self.servidor.status && self.servidor.status == 4) {
      self.carreiras = [...self.carreirasExonerado];
    }

    console.log("Servidor", self.servidor);

    self.servidor.data_ingresso_servico_publico = moment
      .utc(self.servidor.data_ingresso_servico_publico)
      .format("DDMMYYYY");
    self.servidor.data_ingresso_carteira = moment
      .utc(self.servidor.data_ingresso_carteira)
      .format("DDMMYYYY");
    self.servidor.data_ingresso_ente = moment
      .utc(self.servidor.data_ingresso_ente)
      .format("DDMMYYYY");

    const matriculas = this.getMatriculasParaAbas();
    if (matriculas.length > 0) {
      const matriculaSelecionada = matriculas.find(
        item => idMatriculaSelecionada != null && item.id == idMatriculaSelecionada
      ) || matriculas[0];
      this.selecionarMatriculaFuncional(matriculaSelecionada);
    } else {
      this.filterDadosByMatricula(null);
    }

    await self.spinner.hide();
  }

  async filterDadosByMatricula(matricula) {
    const self = this;
    const matriculas = this.getMatriculasParaAbas();

    if (matriculas.length === 0) {
      // Exibir apenas movimentos mensais com matrícula "null"
      this.movimentosMensaisFiltered = this.movimentosMensais.filter(
        (movimento) => movimento.matricula === null || movimento.matricula === "null"
      );
      this.cargosAnterioresFiltered = this.cargosAnteriores.filter(
        (cargo) => cargo.matricula === null || cargo.matricula === "null"
      );
    } else if (matriculas.length === 1) {
      this.movimentosMensaisFiltered = this.movimentosMensais;
      this.cargosAnterioresFiltered = this.cargosAnteriores;
    } else {
      const index = matriculas.findIndex(
        item => String(item.matricula || '').trim() === String(matricula || '').trim()
      );

      if (index === 0) {
        this.movimentosMensaisFiltered = this.movimentosMensais.filter(
          (movimento) =>
            movimento.matricula === matricula || 
            movimento.matricula === null || 
            movimento.matricula === "null"
        );
        this.cargosAnterioresFiltered = this.cargosAnteriores.filter(
          (cargo) => 
            cargo.matricula === matricula || 
            cargo.matricula === null || 
            cargo.matricula === "null"
        );
      } else {
        this.movimentosMensaisFiltered = this.movimentosMensais.filter(
          (movimento) => movimento.matricula === matricula
        );
        this.cargosAnterioresFiltered = this.cargosAnteriores.filter(
          (cargo) => cargo.matricula === matricula
        );
      }
    }
    this.populateChartData();
  }

  getMatriculasServidor(): any[] {
    return MatriculaServidorHelper.getMatriculas(this.servidor, this.idCidade);
  }

  getMatriculasParaAbas(): any[] {
    return this.getMatriculasServidor();
  }

  getIdTabMatricula(matricula: any): string {
    return String(matricula && matricula.id);
  }

  private getMovimentoDaMatricula(matricula: any): any {
    if (!matricula) return null;
    return this.movimentosFuncionais.find(
      movimento => movimento.id_matricula != null && movimento.id_matricula == matricula.id
    );
  }

  private selecionarMatriculaFuncional(matricula: any): void {
    if (!matricula) return;

    this.matriculaTabAtiva = this.getIdTabMatricula(matricula);
    const movimento = this.getMovimentoDaMatricula(matricula);
    if (movimento) {
      this.movimentoSelecionado = { ...movimento };
      this.movimentoSelecionado.id_matricula = matricula.id;
    } else {
      this.resetaMovimento();
      this.movimentoSelecionado.id_matricula = matricula.id;
      this.movimentoSelecionado.id_servidor = this.idServidor;
      this.movimentoSelecionado.matricula = matricula.matricula;
      this.movimentoSelecionado.orgao = matricula.orgao;
    }

    this.movimentoSelecionado.orgao = this.movimentoSelecionado.orgao != null
      ? +this.movimentoSelecionado.orgao
      : null;
    this.movimentoSelecionado.situacao_funcional = this.movimentoSelecionado.situacao_funcional != null
      ? +this.movimentoSelecionado.situacao_funcional
      : null;
    this.movimentoSelecionado.carreira = this.movimentoSelecionado.carreira != null
      ? +this.movimentoSelecionado.carreira
      : null;
    this.movimentoSelecionado.cargo_acumulacao = this.movimentoSelecionado.cargo_acumulacao != null
      ? +this.movimentoSelecionado.cargo_acumulacao
      : null;
    this.filterDadosByMatricula(matricula.matricula);
  }

  getStatusMatriculaMovimento(movimento: any): number {
    const matriculas = this.getMatriculasServidor();
    const numero = String(movimento && movimento.matricula || '').trim();
    const matricula = matriculas.find(item =>
      movimento && movimento.id_matricula != null && item.id == movimento.id_matricula
    ) || matriculas.find(item =>
      numero && String(item.matricula || '').trim() === numero
    );

    return +(matricula && matricula.status != null
      ? matricula.status
      : this.servidor && this.servidor.status);
  }

  getStatusClass(status: number): string {
    return `status-${status}`;
  }

  getStatusLabel(status: number): string {
    const statusMap = {
      1: 'Ativo',
      2: 'Aposentado',
      3: 'Pensionista',
      4: 'Exonerado',
      5: 'Falecido'
    };
    return statusMap[+status] || 'Sem status';
  }

  populateChartData() {
    const self = this;

    console.log("populateChartData", this.movimentosMensaisFiltered);

    // Verificar se há dados para popular o gráfico
    if (!this.movimentosMensaisFiltered || this.movimentosMensaisFiltered.length === 0) {
      // Limpar dados do gráfico quando não há dados
      this.lineChartData = [];
      this.lineChartLabels = [];
      return;
    }

    const data = this.movimentosMensaisFiltered.map(
      (movimento) => movimento.valor
    );

    console.log("data Populated", data);

    const labels = this.movimentosMensaisFiltered.map((movimento) =>
      moment(movimento.data).format("MM/YYYY")
    );

    this.lineChartData = [
      {
        data: data,
        label: "Remuneração mensal",
      },
    ];

    this.lineChartLabels = labels;
  }

  async download(chave, nome) {
    const url = await this.apiCall
      .get("banco-dados/files/url")
      .pipe(take(1))
      .toPromise();
    if (url) saveAs(url + chave, nome);
  }
  getBeautifulDate(date) {
    return moment(date).add(3, "hours").format("MM/YYYY");
  }
  getBeautifulDateFull(date) {
    return moment(date).add(3, "hours").format("DD/MM/YYYY");
  }
  disableMovimento() {
    if (
      !this.movimentoSelecionado.matricula ||
      !this.movimentoSelecionado.decreto_nomeacao ||
      !this.movimentoSelecionado.data_nomeacao ||
      // || !this.movimentoSelecionado.data_exercicio
      // || !this.movimentoSelecionado.data_posse
      // || !this.movimentoSelecionado.cargo_acumulacao
      // || !this.movimentoSelecionado.regime_previdenciario
      // || !this.movimentoSelecionado.base_legal
      // || !this.movimentoSelecionado.data_movimentacao
      !this.movimentoSelecionado.situacao_funcional ||
      !this.movimentoSelecionado.carreira ||
      !this.movimentoSelecionado.ingresso_carreira ||
      !this.movimentoSelecionado.cargo ||
      !this.movimentoSelecionado.ingresso_cargo ||
      !this.movimentoSelecionado.carga_horaria ||
      !this.movimentoSelecionado.local_trabalho ||
      !this.movimentoSelecionado.abono_permanencia
    ) {
      return true;
    } else {
      return false;
    }
  }
  onChangeOrgao($event) {
    this.movimentoSelecionado.poder_orgao = this.orgaos.find(
      (x) => x.id == this.movimentoSelecionado.orgao
    ).poder;
  }
  async exportar() {
    let listaFormatada = [];
    for (let s of this.movimentosMensais) {
      listaFormatada.push({
        Salário: s.valor,
        Data: moment(s.data).format("MM/YYYY"),
      });
    }

    this.excelService.exportAsExcelFile(
      JSON.parse(JSON.stringify(listaFormatada)),
      "movimentos_mensais"
    );
  }

  async importar() {
    const self = this;
    const { value: file } = await Swal.fire({
      title: "Selecione a planilha para importar",
      input: "file",
      inputAttributes: {
        accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
        "aria-label": "Selecione a planilha",
      },
    });

    if (!file) {
      await this.app.alert(
        "Atenção!",
        "Você deve informar uma planilha!",
        "error"
      );
      return;
    }

    if (!(file as any).name.endsWith("xlsx")) {
      await this.app.alert(
        "Atenção!",
        "Você deve informar planilhas no formato .xlsx!",
        "error"
      );
      return;
    }
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file as any);
    fileReader.onload = async (e) => {
      const formData = new FormData();
      formData.append("file", file as any);
      try {
        self.spinner.show(undefined, {
          type: "ball-triangle-path",
          size: "medium",
          bdColor: "rgba(0, 0, 0, 0.8)",
          color: "#fff",
          fullScreen: true,
        });

        await this.apiCall
          .post(
            "servidor/arquivo/servidores/salario?servidor=" +
              self.idServidor +
              "&matricula=" +
              self.movimentoSelecionado.matricula,
            formData
          )
          .pipe(take(1))
          .toPromise();
        self.spinner.hide();
        await this.app.alert(
          "Tudo certo!",
          "Movimento Mensal importado com sucesso!",
          "success"
        );
        self.ngOnInit();
      } catch (e) {
        self.ngOnInit();
      }
    };
  }

  newMovement(content) {
    this.resetaMovimento();
    this.resetaCargo();
    this.resetaSalario();

    const modal = this.modalService.open(content, {
      centered: true,
      size: "xl",
    });
  }

  openModalXl(content, movimento, cargo, salario, size = "xl") {
    console.log("modal", size);

    if (movimento) {
      this.resetaMovimento();

      this.movimentoSelecionado = movimento;
      this.movimentoSelecionado.cargo_acumulacao =
        +this.movimentoSelecionado.cargo_acumulacao;
      this.movimentoSelecionado.orgao = +this.movimentoSelecionado.orgao;
      this.movimentoSelecionado.situacao_funcional =
        +this.movimentoSelecionado.situacao_funcional;
      this.movimentoSelecionado.carreira = +this.movimentoSelecionado.carreira;
      if (this.movimentoSelecionado.salario_base)
        this.movimentoSelecionado.salario_base = this.formatMonetaryValueForDisplay(
          this.movimentoSelecionado.salario_base
        );
      if (this.movimentoSelecionado.nivel_classe)
        this.movimentoSelecionado.nivel_classe = this.formatMonetaryValueForDisplay(
          this.movimentoSelecionado.nivel_classe
        );
      if (this.movimentoSelecionado.total)
        this.movimentoSelecionado.total = this.formatMonetaryValueForDisplay(
          this.movimentoSelecionado.total
        );
    }
    if (cargo) {
      this.resetaCargo();

      this.cargo = cargo;
      if (this.cargo.inicio)
        this.cargo.inicio = moment(this.cargo.inicio).format("DDMMYYYY");
      if (this.cargo.fim)
        this.cargo.fim = moment(this.cargo.fim).format("DDMMYYYY");
      if (this.cargo.salario)
        this.cargo.salario = this.formatMonetaryValueForDisplay(this.cargo.salario);
    }
    if (salario) {
      this.resetaSalario();

      this.salario = salario;
      if (this.salario.data)
        this.salario.data = moment(this.salario.data).format("MMYYYY");
      if (this.salario.valor)
        this.salario.valor = this.formatMonetaryValueForDisplay(this.salario.valor);
    }
    const modal = this.modalService.open(content, {
      centered: true,
      size: size,
    });
  }

  resetaCargo() {
    this.cargo = {
      id: null,
      id_servidor: null,
      cargo: null,
      salario: null,
      inicio: null,
      fim: null,
    };
  }
  resetaSalario() {
    this.salario = {
      id: null,
      id_servidor: null,
      valor: null,
      data: null,
      observacoes: null,
    };
  }
  disableSalario() {
    if (!this.salario.valor || !this.salario.data) {
      return true;
    } else {
      return false;
    }
  }
  disableCargo() {
    if (
      !this.cargo.cargo ||
      !this.cargo.inicio ||
      !this.cargo.salario ||
      !this.cargo.fim
    ) {
      return true;
    } else {
      return false;
    }
  }
  resetaMovimento() {
    this.movimentoSelecionado = {
      id: null,
      id_servidor: null,
      id_matricula: null,
      tipo_vinculo: "Concursado",
      matricula: null,
      decreto_nomeacao: null,
      data_nomeacao: null,
      data_exercicio: null,
      classificacao_concurso: null,
      edital_concurso: null,
      data_posse: null,
      ente_origem: null,
      cargo_acumulacao: null,
      compatibilidade_horario: null,
      detalhes_acumulacao: null,
      regime_previdenciario: null,
      resolucao_registro: null,
      lei_autorizativa: null,
      base_legal: null,
      data_movimentacao: null,
      situacao_funcional: null,
      orgao: null,
      poder_orgao: null,
      carreira: null,
      ingresso_carreira: null,
      cargo: null,
      ingresso_cargo: null,
      carga_horaria: null,
      data_saida: null,
      tipo_exoneracao: null,
      local_trabalho: null,
      salario_base: null,
      nivel_classe: null,
      total: null,
      abono_permanencia: null,
      competencia_inicial: null,
      observacoes: null,
      tipo_fundo: null,
    };
    const dadosUsuario = this.me.currentUserValue;
    const json = JSON.parse(JSON.stringify(dadosUsuario));
    const cidade = json.user.cidade;
    const nomeCidade = json.user.nomeCidade;
    this.movimentoSelecionado.ente_origem =
      "Prefeitura Municipal de " + nomeCidade;
  }
  // Função auxiliar para normalizar valores monetários (formato brasileiro -> formato numérico)
  // Entrada esperada: formato brasileiro "1.234,56" ou "1234,56" ou "1234" ou "R$1.234,56"
  // Saída: formato numérico "1234.56"
  normalizeMonetaryValue(value: any): string {
    // Trata valores null, undefined ou string vazia
    if (value === null || value === undefined || value === "") return "";
    
    // Se for número, converte para string com 2 casas decimais
    if (typeof value === 'number') {
      return value.toFixed(2);
    }
    
    // Se for string, normaliza
    let str = value.toString().trim();
    
    // Remove prefixo "R$" e espaços
    str = str.replace(/R\$\s*/g, "").trim();
    
    if (str === "" || str === "0" || str === "0,00" || str === "0.00") return "";
    
    // Detecta o formato do valor analisando os separadores
    const hasComma = str.includes(",");
    const hasDot = str.includes(".");
    
    if (hasComma && hasDot) {
      // Formato brasileiro completo: "1.234,56"
      // Ponto é separador de milhar, vírgula é separador decimal
      str = str.replace(/\./g, ""); // Remove separadores de milhar
      str = str.replace(",", "."); // Converte vírgula decimal para ponto
    } else if (hasComma && !hasDot) {
      // Formato brasileiro sem milhar: "1234,56"
      // Vírgula é separador decimal
      str = str.replace(",", ".");
    } else if (hasDot && !hasComma) {
      // Pode ser formato brasileiro com milhar "1.234" ou formato americano "12.34"
      // Analisa a posição do ponto para determinar
      const parts = str.split(".");
      const lastPart = parts[parts.length - 1];
      
      if (lastPart.length === 3 && parts.length > 1) {
        // Ex: "1.234" ou "1.234.567" - ponto é separador de milhar (3 dígitos após)
        str = str.replace(/\./g, ""); // Remove todos os pontos (são separadores de milhar)
      }
      // Se tem 1 ou 2 dígitos após o último ponto, é separador decimal - mantém como está
      // Ex: "12.34" ou "12.5" - já está no formato correto
    }
    // Se não tem vírgula nem ponto, é um número inteiro - mantém como está
    
    // Valida se é um número válido
    const numValue = parseFloat(str);
    if (isNaN(numValue)) {
      return "";
    }
    
    // Retorna com 2 casas decimais garantidas
    return numValue.toFixed(2);
  }

  // Função auxiliar para formatar valores monetários para exibição (número ou string -> string formatada)
  formatMonetaryValueForDisplay(value: any): string {
    if (!value && value !== 0) return "";
    // Se for número, formata para exibição
    if (typeof value === 'number') {
      return value.toFixed(2).toString().replace(".", ",");
    }
    // Se já for string formatada, verifica se precisa reformatar
    else if (typeof value === 'string') {
      // Se já está no formato correto (tem vírgula), mantém
      if (value.includes(',') && !value.includes('.')) {
        return value;
      }
      // Caso contrário, normaliza e reformata
      const numValue = parseFloat(this.normalizeMonetaryValue(value));
      if (!isNaN(numValue)) {
        return numValue.toFixed(2).toString().replace(".", ",");
      }
    }
    return value.toString();
  }

  onChangeSalario() {
    let salario = this.movimentoSelecionado.salario_base;
    let extras = this.movimentoSelecionado.nivel_classe;
    this.movimentoSelecionado.total = 0;
    if (salario) {
      salario = +this.normalizeMonetaryValue(salario);
      this.movimentoSelecionado.total =
        this.movimentoSelecionado.total + salario;
    }
    if (extras) {
      extras = +this.normalizeMonetaryValue(extras);
      this.movimentoSelecionado.total =
        this.movimentoSelecionado.total + extras;
    }
    if (this.movimentoSelecionado.total)
      this.movimentoSelecionado.total = this.formatMonetaryValueForDisplay(
        this.movimentoSelecionado.total
      );
  }

  async atualizarServidor() {
    const self = this;

    if (!self.idServidor) {
      return;
    }
    await self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    const data_ingresso_servico_publico = this.preparaData(
      self.servidor.data_ingresso_servico_publico
    );
    const data_ingresso_carteira = this.preparaData(
      self.servidor.data_ingresso_carteira
    );
    const data_ingresso_ente = this.preparaData(
      self.servidor.data_ingresso_ente
    );
    await self.apiCall
      .get(
        `servidor/movimentos/servidor?id_servidor=${self.idServidor}&data_ingresso_servico_publico=${data_ingresso_servico_publico}&data_ingresso_carteira=${data_ingresso_carteira}&data_ingresso_ente=${data_ingresso_ente}&emprego_carteira=${self.servidor.emprego_carteira}`
      )
      .pipe(take(1))
      .toPromise();
    await self.spinner.hide();
    this.isEditingGeneralData = false;
    self.ngOnInit();

  }
  async atualizarOuCadastrarSalario(modal) {
    const self = this;
    if (!self.salario || !self.idServidor) {
      return;
    }
    let salario = { ...self.salario };
    salario.data = moment(salario.data, "MMYYYY")
      .add(1, "day")
      .format("YYYY-MM-DD");
    salario.valor = this.normalizeMonetaryValue(salario.valor);
    salario.observacoes = salario.observacoes ? salario.observacoes : "";
    
    // Determinar a matrícula para o movimento mensal
    let matriculaParaMovimento = null;
    if (self.movimentoSelecionado && self.movimentoSelecionado.matricula) {
      matriculaParaMovimento = self.movimentoSelecionado.matricula;
    }
    
    if (!self.salario.id) {
      await self.apiCall
        .get(
          `servidor/movimentos/movimentacoesmensais/inserir?id_servidor=${self.idServidor}&valor=${salario.valor}&data=${salario.data}&observacoes=${salario.observacoes}&matricula=${matriculaParaMovimento}`
        )
        .pipe(take(1))
        .toPromise();
    } else {
      await self.apiCall
        .get(
          `servidor/movimentos/movimentacoesmensais/atualizar?id=${self.salario.id}&valor=${salario.valor}&data=${salario.data}&observacoes=${salario.observacoes}`
        )
        .pipe(take(1))
        .toPromise();
    }
    await this.app.alert(
      "Tudo certo!",
      self.salario.id
        ? "Movimento Mensal atualizado com sucesso!"
        : "Movimento Mensal cadastrado com sucesso!",
      "success"
    );
    modal.close("Close click");
    self.ngOnInit();
  }
  async atualizarOuCadastrarCargo(modal) {
    const self = this;
    console.log("cargo", self.cargo);
    console.log("idServidor", self.idServidor);
    console.log("movimentoSelecionado", this.movimentoSelecionado);
    if (
      !self.cargo ||
      !self.idServidor ||
      !self.movimentoSelecionado ||
      !self.movimentoSelecionado.matricula
    ) {
      console.log("caiu no return");
      return;
    }
    let cargo = { ...self.cargo };
    cargo.inicio = this.preparaData(cargo.inicio);
    cargo.fim = this.preparaData(cargo.fim);
    cargo.salario = this.normalizeMonetaryValue(cargo.salario);
    if (!self.cargo.id) {
      await self.apiCall
        .get(
          `servidor/movimentos/cargosanteriores/inserir?id_servidor=${self.idServidor}&valor=${this.cargo.cargo}&salario=${cargo.salario}&inicio=${cargo.inicio}&fim=${cargo.fim}&cargo=${cargo.cargo}&matricula=${self.movimentoSelecionado.matricula}`
        )
        .pipe(take(1))
        .toPromise();
    } else {
      await self.apiCall
        .get(
          `servidor/movimentos/cargosanteriores/atualizar?id=${self.cargo.id}&valor=${this.cargo.cargo}&salario=${cargo.salario}&inicio=${cargo.inicio}&fim=${cargo.fim}&cargo=${cargo.cargo}&matricula=${self.movimentoSelecionado.matricula}` //&id_servidor=${self.idServidor}
        )
        .pipe(take(1))
        .toPromise();
    }
    await this.app.alert(
      "Tudo certo!",
      self.cargo.id
        ? "Cargo Anterior atualizado com sucesso!"
        : "Cargo Anterior cadastrado com sucesso!",
      "success"
    );
    modal.close("Close click");
    self.ngOnInit();
  }
  async atualizarOuCadastrar(modal) {
    const self = this;
    if (!self.movimentoSelecionado || !self.idServidor) {
      return;
    }
    if (
      !self.movimentoSelecionado.id &&
      !/^\d+$/.test(String(self.movimentoSelecionado.matricula || ""))
    ) {
      await this.app.alert(
        "Atenção!",
        "Use somente números no campo de matrícula.",
        "warning"
      );
      return;
    }
    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    console.log("movimento", this.movimentoSelecionado);
    this.movimentoSelecionado.data_nomeacao = this.preparaData(
      this.movimentoSelecionado.data_nomeacao
    );
    this.movimentoSelecionado.data_exercicio = this.preparaData(
      this.movimentoSelecionado.data_exercicio
    );
    this.movimentoSelecionado.data_posse = this.preparaData(
      this.movimentoSelecionado.data_posse
    );
    this.movimentoSelecionado.data_movimentacao = this.preparaData(
      this.movimentoSelecionado.data_movimentacao
    );
    this.movimentoSelecionado.data_saida = this.preparaData(
      this.movimentoSelecionado.data_saida
    );
    this.movimentoSelecionado.competencia_inicial = this.preparaData(
      this.movimentoSelecionado.competencia_inicial
    );
    this.movimentoSelecionado.ingresso_carreira = this.preparaData(
      this.movimentoSelecionado.ingresso_carreira
    );
    this.movimentoSelecionado.ingresso_cargo = this.preparaData(
      this.movimentoSelecionado.ingresso_cargo
    );
    // Sempre normaliza valores monetários, mesmo que não tenham sido alterados
    // Isso garante que valores formatados como string "1231,44" sejam convertidos para "1231.44"
    // A função normalizeMonetaryValue já trata valores null/undefined/vazios retornando string vazia
    let salario = this.normalizeMonetaryValue(this.movimentoSelecionado.salario_base);
    let nivel_classe = this.normalizeMonetaryValue(this.movimentoSelecionado.nivel_classe);
    let total = this.normalizeMonetaryValue(this.movimentoSelecionado.total);
    if (self.movimentoSelecionado.id) {
      await self.apiCall
        .get(
          `servidor/movimentos/editar?id_movimento=${
            self.movimentoSelecionado.id
          }&id_servidor=${self.idServidor}&id_matricula=${self.movimentoSelecionado.id_matricula || ''}&tipo_vinculo=${this.movimentoSelecionado.tipo_vinculo}&matricula=${
            this.movimentoSelecionado.matricula
          }&decreto_nomeacao=${
            this.movimentoSelecionado.decreto_nomeacao
          }&data_nomeacao=${
            this.movimentoSelecionado.data_nomeacao
          }&data_exercicio=${
            this.movimentoSelecionado.data_exercicio
          }&classificacao_concurso=${
            this.movimentoSelecionado.classificacao_concurso
          }&edital_concurso=${
            this.movimentoSelecionado.edital_concurso
          }&data_posse=${this.movimentoSelecionado.data_posse}&ente_origem=${
            this.movimentoSelecionado.ente_origem
          }&cargo_acumulacao=${
            this.movimentoSelecionado.cargo_acumulacao
          }&detalhes_acumulacao=${
            this.movimentoSelecionado.detalhes_acumulacao
          }&compatibilidade_horario=${
            this.movimentoSelecionado.compatibilidade_horario
          }&regime_previdenciario=${
            this.movimentoSelecionado.regime_previdenciario
          }&resolucao_registro=${
            this.movimentoSelecionado.resolucao_registro
          }&lei_autorizativa=${
            this.movimentoSelecionado.lei_autorizativa
          }&base_legal=${
            this.movimentoSelecionado.base_legal
          }&data_movimentacao=${
            this.movimentoSelecionado.data_movimentacao
          }&situacao_funcional=${
            this.movimentoSelecionado.situacao_funcional
          }&orgao=${this.movimentoSelecionado.orgao}&poder_orgao=${
            this.movimentoSelecionado.poder_orgao
          }&carreira=${this.movimentoSelecionado.carreira}&ingresso_carreira=${
            this.movimentoSelecionado.ingresso_carreira
          }&cargo=${this.movimentoSelecionado.cargo}&ingresso_cargo=${
            this.movimentoSelecionado.ingresso_cargo
          }&carga_horaria=${
            this.movimentoSelecionado.carga_horaria
          }&data_saida=${
            this.movimentoSelecionado.data_saida
          }&tipo_exoneracao=${
            this.movimentoSelecionado.tipo_exoneracao
          }&local_trabalho=${
            this.movimentoSelecionado.local_trabalho
          }&salario_base=${salario}&nivel_classe=${nivel_classe}&total=${total}&periodo_rgps=${""}&abono_permanencia=${
            this.movimentoSelecionado.abono_permanencia
          }&competencia_inicial=${
            this.movimentoSelecionado.competencia_inicial
          }&inicio_rgps=${""}&fim_rgps=${""}&observacoes=${
            this.movimentoSelecionado.observacoes
          }&tipo_fundo=${this.movimentoSelecionado.tipo_fundo}`
        )
        .pipe(take(1))
        .toPromise();
    } else {
      try {
        const resposta: any = await self.apiCall
          .post("servidor/matricula/novo", {
            id_servidor: self.idServidor,
            id_cidade: self.idCidade,
            matricula: self.movimentoSelecionado.matricula,
            status: self.movimentoSelecionado.situacao_funcional,
            orgao: self.movimentoSelecionado.orgao,
            movimento: {
              ...self.movimentoSelecionado,
              salario_base: salario,
              nivel_classe,
              total,
              periodo_rgps: "",
              inicio_rgps: "",
              fim_rgps: "",
            },
          })
          .pipe(take(1))
          .toPromise();
        self.movimentoSelecionado.id_matricula =
          resposta && (resposta.id || resposta.id_matricula);
      } catch (error) {
        self.spinner.hide();
        const respostaErro = error && error.error;
        const mensagem =
          (respostaErro && respostaErro.message) ||
          (typeof respostaErro === "string" && respostaErro) ||
          (error && error.message) ||
          "Não foi possível cadastrar a matrícula.";
        await this.app.alert("Atenção!", mensagem, "warning");
        return;
      }
    }
    self.spinner.hide();
    
    // Fechar a modal se for um novo cadastro (sem id)
    if (!self.movimentoSelecionado.id) {
      modal.close();
    }
    
    await this.app.alert(
      "Tudo certo!",
      self.movimentoSelecionado.id
        ? "Matrícula atualizada com sucesso!"
        : "Matrícula cadastrada com sucesso!",
      "success"
    );
    this.isEditingMatricula = false;
    await self.ngOnInit();
  }

  preparaData(data) {
    if (data) {
      return moment(data, "DDMMYYYY").format("YYYY-MM-DD");
    } else {
      data = "";
    }
    return data;
  }

  onTabChange(event: any) {
    if (this.isEditingMatricula) {
      event.preventDefault();
      this.app.alert(
        "Atenção!",
        "Você está editando uma matrícula, finalize a edição antes de mudar de aba!"
      );
    } else {
      const matricula = this.getMatriculasParaAbas().find(
        item => this.getIdTabMatricula(item) === String(event.nextId)
      );
      this.selecionarMatriculaFuncional(matricula);
    }
  }

  toggleEditMatricula(revert = false) {
    if (revert == false) {
      this.clonedMatricula = JSON.parse(
        JSON.stringify(this.movimentoSelecionado)
      );
    }

    if (revert == true) {
      this.movimentoSelecionado = JSON.parse(
        JSON.stringify(this.clonedMatricula)
      );
    }
    this.isEditingMatricula = !this.isEditingMatricula;
  }

  onCancelMatricula(modal: any): void {
    this.resetaMovimento();
    modal.close();
  }

  onCancelCargo(modal: any): void {
    this.resetaCargo();
    modal.close();
  }

  onCancelSalario(modal: any): void {
    this.resetaSalario();
    modal.close();
  }

  toggleEditGeneralData(revert = false) {
    if (revert == false) {
      this.clonedGeneralDate = JSON.parse(JSON.stringify(this.servidor));
    }

    if (revert == true) {
      this.servidor = JSON.parse(JSON.stringify(this.clonedGeneralDate));
    }
    this.isEditingGeneralData = !this.isEditingGeneralData;
  }

  chartHovered(event) {
    console.log("hover");
    return;
  }
  chartClicked(event) {
    console.log("click");
    return;
  }

  async applyFilters() {
    const { fromDate, toDate, order, limit } = this.filterForm.value;

    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;

    await this.filterDadosByMatricula(this.movimentoSelecionado.matricula);

    // Aplicando filtro nos dois arrays com campos distintos
    this.movimentosMensaisFiltered = this.filtrarArrayPorData(
      this.movimentosMensaisFiltered,
      "data",
      from,
      to,
      order,
      limit
    );

    this.cargosAnterioresFiltered = this.filtrarArrayPorData(
      this.cargosAnterioresFiltered,
      "inicio",
      from,
      to,
      order,
      limit
    );

    this.populateChartData();
  }

  async resetFilters() {
    this.filterForm.reset({
      fromDate: "",
      toDate: "",
      order: "desc",
      limit: 3,
    });

    await this.filterDadosByMatricula(this.movimentoSelecionado.matricula);

    this.populateChartData();
  }

  private filtrarArrayPorData<T>(
    array: T[],
    campoData: keyof T,
    from: Date | null,
    to: Date | null,
    order: "asc" | "desc",
    limit: number | null
  ): T[] {
    let result = [...array];

    if (from) {
      result = result.filter(
        (item) => new Date(item[campoData] as any) >= from
      );
    }
    if (to) {
      result = result.filter((item) => new Date(item[campoData] as any) <= to);
    }

    result.sort((a, b) => {
      const dateA = new Date(a[campoData] as any);
      const dateB = new Date(b[campoData] as any);
      return order === "asc"
        ? dateA.getTime() - dateB.getTime()
        : dateB.getTime() - dateA.getTime();
    });

    if (limit && limit > 0) {
      result = result.slice(0, limit);
    }

    return result;
  }

  async deletarMovimentoMensal(idMovimento: number) {
    const self = this;
    
    // Confirmar antes de deletar
    const confirmacao = await Swal.fire({
      title: 'Tem certeza?',
      text: 'Esta ação não pode ser desfeita!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sim, deletar!',
      cancelButtonText: 'Cancelar'
    });

    if (confirmacao.isConfirmed) {
      try {
        await self.spinner.show(undefined, {
          type: "ball-triangle-path",
          size: "medium",
          bdColor: "rgba(0, 0, 0, 0.8)",
          color: "#fff",
          fullScreen: true,
        });

        await self.apiCall
          .get(`servidor/movimentos/movimentacoesmensais/remover?id_movimento=${idMovimento}`)
          .pipe(take(1))
          .toPromise();

        await self.spinner.hide();

        await this.app.alert(
          "Sucesso!",
          "Movimento mensal deletado com sucesso!",
          "success"
        );

        // Recarregar os dados
        self.ngOnInit();
      } catch (error) {
        await self.spinner.hide();
        await this.app.alert(
          "Erro!",
          "Erro ao deletar movimento mensal. Tente novamente.",
          "error"
        );
        console.error('Erro ao deletar movimento mensal:', error);
      }
    }
  }

  async deletarCargoAnterior(idCargo: number) {
    const self = this;
    
    // Confirmar antes de deletar
    const confirmacao = await Swal.fire({
      title: 'Tem certeza?',
      text: 'Esta ação não pode ser desfeita!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sim, deletar!',
      cancelButtonText: 'Cancelar'
    });

    if (confirmacao.isConfirmed) {
      try {
        await self.spinner.show(undefined, {
          type: "ball-triangle-path",
          size: "medium",
          bdColor: "rgba(0, 0, 0, 0.8)",
          color: "#fff",
          fullScreen: true,
        });

        await self.apiCall
          .get(`servidor/movimentos/cargosanteriores/remover?id_movimento=${idCargo}`)
          .pipe(take(1))
          .toPromise();

        await self.spinner.hide();

        await this.app.alert(
          "Sucesso!",
          "Cargo anterior deletado com sucesso!",
          "success"
        );

        // Recarregar os dados
        self.ngOnInit();
      } catch (error) {
        await self.spinner.hide();
        await this.app.alert(
          "Erro!",
          "Erro ao deletar cargo anterior. Tente novamente.",
          "error"
        );
        console.error('Erro ao deletar cargo anterior:', error);
      }
    }
  }

  returnPage(){
    window.history.back();
  }
}
